import validate from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+node@26.2.0_@vue+c_99fd2ebdea5cab1275842f3da6e8f812/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/nuxtWeb/middleware/auth.global.ts";
import domain_45redirect_45global from "/nuxtWeb/middleware/domainRedirect.global.ts";
import manifest_45route_45rule from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+node@26.2.0_@vue+c_99fd2ebdea5cab1275842f3da6e8f812/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  domain_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/nuxtWeb/middleware/auth.ts")
}